module.exports = __webpack_public_path__ + "img/style12.1ada164a.png";